export function loadScript(url, identifier) {
  return new Promise((resolve, reject) => {
    const scriptElement = document.createElement('script');
    scriptElement.src = url;
    scriptElement.async = true;
    scriptElement.onload = () => resolve();
    scriptElement.onerror = () => reject(new Error(`Failed to load script asset for app ${identifier} - ${url}`));
    scriptElement.dataset.appId = identifier;
    // Set the crossOrigin to true in development mode in order to correctly
    // handle errors thrown by react in separate bundles. For more info see
    // https://reactjs.org/docs/cross-origin-errors.html
    if (__DEV__) {
      scriptElement.crossOrigin = true;
    }
    document.body.appendChild(scriptElement);
  });
}

export const loadStyle = (url, identifier) => {
  return new Promise((resolve, reject) => {
    const styleElement = document.createElement('link');
    styleElement.type = 'text/css';
    styleElement.rel = 'stylesheet';
    styleElement.href = url;
    styleElement.onload = () => resolve();
    styleElement.onerror = () => reject(new Error(`Failed to load style asset for app ${identifier} - ${url}`));
    styleElement.dataset.appId = identifier;
    document.head.appendChild(styleElement);
  });
};

export const mount = (element, container) => {
  container.appendChild(element);
};
